
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../language/LanguageContext";
import "./Navigation.scss"; // Import der CSS-Datei
import * as Constants from "../../Constants";
import { Link } from "react-router-dom";
import { slide as Menu } from 'react-burger-menu';
import LanguageSelector from '../pageComponents/LanguageSelector';
import {Collapse} from 'react-collapse';
import { NavigationContext } from './NavigationContext';
import { useLocation } from 'react-router-dom';

// Move links object outside the component
const links = {
    "tenths": Constants.TWO_THOUSAND_TEN_TO_TWO_THOUSAND_TWENTY_FIVE_ROUTE,       
    "ninety": Constants.NINETEEN_NINETY_TO_TWO_THOUSAND_NINE_ROUTE,
    "eighty": Constants.NINETEEN_EIGHTY_TO_NINETEEN_NINETY_ROUTE,
    "graphic": Constants.GRAPHIC_ROUTE,
    "drawing": Constants.DRAWING_ROUTE,
    "acryl": Constants.ACRYL_ROUTE,
    "travel": Constants.TRAVEL_ROUTE,
    "portrait": Constants.PORTRAIT_ROUTE,
    "hansZitko": Constants.HANS_ZITKO_ROUTE,
    "timSommer": Constants.TIM_SOMMER_ROUTE,
    "constanzeTreuner": Constants.CONSTANZE_TREUNER_ROUTE,
    "simoneTippachSchneider": Constants.SIMONE_TIPPACH_SCHNEIDER_ROUTE
};

const Navigation = () => {
    const { dictionary } = useContext(LanguageContext);
    const [isOpen, setIsOpen] = useState(false); // State to manage menu open/close
    const { openSection, setOpenSection, openHoverSection, setOpenHoverSection } = useContext(NavigationContext); // Use global state

    const location = useLocation();


    const currentPath = location.pathname;

    // Open section if current path matches a sub-link (but not during render)
    useEffect(() => {
        let foundSection = null;
        Object.entries(dictionary.navigation).forEach(([key, subItems]) => {
            Object.entries(subItems).forEach(([subKey, subValue]) => {
                if (links[subKey] === currentPath) {
                    foundSection = key;
                }
            });
        });
        if (foundSection) {
            setOpenSection(foundSection);
        }
    }, [currentPath, dictionary.navigation, setOpenSection]);

    const handleLinkClick = (key) => {
        Object.entries(dictionary.navigation).forEach(([navKey, subItems]) => {
            Object.entries(subItems).forEach(([subKey, subValue]) => {
                if (links[subKey] === currentPath) {
                    setOpenSection(navKey);
                }
            });
        });
      
        setIsOpen(false); // Close the menu when a link is clicked
    };

    const handleSectionClick = (key) => {
        setOpenSection(key);
    };

    // Handle hover to open section
    const handleSectionMouseEnter = (key) => {
        setOpenHoverSection(key);
    };
    const handleSectionMouseLeave = (key) => {
        setOpenHoverSection(prev => (prev === key ? null : prev));
    };

    const renderSubItems = (subItems, sectionKey) => {
        return Object.entries(subItems)
            .map(([key, value]) => (
            <Link
                key={key}
                tabIndex={openSection === sectionKey ? "0" : "-1"}
                to={links[key]}
                className="sub-item fancy-link"
                onClick={() => handleLinkClick(key)} // Add onClick handler
            >
                {value}
            </Link>
            ));
    };

    const renderNavigationItems = (mobileView = false) => {
        return Object.entries(dictionary.navigation).map(([key, subItems], index) => (
            <div
                key={key}
                className="nav-section"
                onMouseEnter={!mobileView ? () => handleSectionMouseEnter(key) : undefined}
                onMouseLeave={!mobileView ? () => handleSectionMouseLeave(key) : undefined}
            >
                <span
                    className={`nav-title${mobileView ? ' fancy-link' : ''}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => handleSectionClick(key)}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleSectionClick(key);
                        }
                    }}
                >
                    {key}
                </span>
                {mobileView ? (
                    <Collapse isOpened={openSection === key || openHoverSection === key}>
                        <div className="sub-list">
                            {renderSubItems(subItems)}
                        </div>
                    </Collapse>
                ) : (
                    <div className={`sub-list${openSection === key || openHoverSection === key ? "" : " hidden-sub-list"}`}>
                        {renderSubItems(subItems, key)}
                    </div>
                )}
            </div>
        ));
    };

    return (
        <div className="navigation-container">
            <div className="mobile-navigation-wrapper">
                <Menu isOpen={isOpen} onStateChange={({ isOpen }) => setIsOpen(isOpen)} right>
                    {renderNavigationItems(true)}
                    <Link to={Constants.BIOGRAPHY_ROUTE} className="fancy-link right-links">{dictionary.other_links.biography}</Link>
                    <Link to={Constants.CONTACT_ROUTE} className="fancy-link right-links">{dictionary.other_links.contact}</Link>
                    <LanguageSelector />
                </Menu>
            </div>
            <div className="desktop-navigation-wrapper">
                <nav className="navigation">
                    {renderNavigationItems(false)}
                    <div className="nav-section">
                        <Link to={Constants.BIOGRAPHY_ROUTE} className="fancy-link right-links">{dictionary.other_links.biography}</Link>
                    </div>
                    <div className="nav-section">
                        <Link to={Constants.CONTACT_ROUTE} className="fancy-link right-links">{dictionary.other_links.contact}</Link>
                    </div>
                    <div className="side-navigation-wrapper end">
                        <LanguageSelector />
                    </div>
                </nav>
            </div>
        
        </div>
    );
};

export default Navigation;